import React from "react";
import Header from "../../containers/Header/Header";
import Home from "./Home";
import AboutMe from "../../containers/AboutMe/AboutMe";
import Projects from "../../containers/Projects/Projects";
import Contact from "../../containers/Contact/Contact";
import "./HomePage.scss";

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />
      <main>
        <Home />
        <AboutMe />
        <Projects/>
        <Contact/>
      </main>
    </div>
  );
};

export default HomePage;
